import React from 'react';
import { Grid, Box } from '@material-ui/core';
import Stepper from 'react-stepper-horizontal';
import logo from '../assets/qmenu_logo.png';

const LogoAndStepper = ({ showStepper, step }) => {
  return (
    <Grid container>
      <Grid item xs={4}>
        <Box m={4}>
          <img height="54px" width="54px" alt="logo" src={logo} />
        </Box>
      </Grid>
      {showStepper ? (
        <Grid item xs={8}>
          <Box m={4}>
            {' '}
            <Stepper
              size={12}
              style={{ padding: '0 !important' }}
              completeBarColor={'#D3D3D3'}
              defaultColor="#D3D3D3"
              steps={[1, 2, 3, 4, 5]}
              completeColor="#CD272F"
              activeColor="#CD272F"
              circleFontSize={0}
              activeStep={step}
            />
          </Box>
        </Grid>
      ) : null}
    </Grid>
  );
};

export default LogoAndStepper;
